<template>
  <div class="UISearchInput">
    <div class="search-wrapper flex align-center flex-nowrap justyify-space-between">
      <UIIconButton
        :custom-icon="'search'"
        :label="searchLabel"
        class="icon-container btn-ghost m-0 small"
      />
      <input
        id="search-input"
        ref="inputEl"
        v-model="search"
        type="text"
        class="search-input"
        :placeholder="searchLabel"
        :aria-label="searchLabel"
        :class="{ active: isInputFocused }"
        @focus="isInputFocused = true"
        @blur="isInputFocused = false"
        @input="updateSearch"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    modelValue: {
      type: String,
      default: '',
    },
  })

  const { trackSearch } = useTracking()
  const router = useRouter()
  const search = ref(props.modelValue || '')
  const searchLabel = 'Zoeken door de website'

  // Is not used, can be used in project
  const isInputFocused = ref(false)
  const inputEl = ref<HTMLInputElement | null>(null)
  defineExpose({
    focus: () => {
      inputEl.value?.focus()
    },
  })

  const emit = defineEmits(['update:modelValue'])
  let searchTimeout: ReturnType<typeof setTimeout>

  function updateSearch() {
    emit('update:modelValue', search.value)

    clearTimeout(searchTimeout)

    if (!search.value.trim()) return

    searchTimeout = setTimeout(() => {
      trackSearch(search.value)
    }, 800)
  }

  function resetSearch() {
    search.value = ''
  }

  onMounted(() => {
    // Resets the search when switching pages
    router.afterEach((to, from) => {
      if (to.path != from.path) {
        resetSearch()
      }
    })

    watch(search, () => {
      updateSearch()
    })
  })

  onUnmounted(() => {
    clearTimeout(searchTimeout)
  })
</script>

<style lang="scss" scoped>
  .search-wrapper {
    position: relative;
    color: $color-text;

    .icon-container {
      margin-right: 2rem;
    }

    .search-input {
      all: unset;
      font-size: 2rem;
      font-weight: 400;
      line-height: 1.4;
      transition: all 0.2s ease-in;
      background-color: transparent;
      color: inherit;
      width: 100%;

      &::placeholder {
        color: inherit;
        opacity: 0.5;
        font-style: normal;
      }
    }
  }
</style>
